import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'

const InformationCardWrapper = styled.div<{ $theme: SystemTheme }>`
  padding: 8px 0;
  margin: 0px 16px;
  color: ${({ $theme }) => $theme.text.placeholder};
  font-size: ${({ $theme }) => $theme.typescale[12].size};
  line-height: ${({ $theme }) => $theme.typescale[12].lineHeight};

  & + div {
    border-top: 1px solid ${({ $theme }) => $theme.common.divider[100]};
  }
`

const InformationCard = ({ message }: { message: ReactNode }) => {
  const theme = useSysTheme()
  return <InformationCardWrapper $theme={theme}>{message}</InformationCardWrapper>
}

export default InformationCard
